//  ==========================================================================
//
//  Case Study (detail page)
//
//  ==========================================================================
import React, { PureComponent } from 'react';

import { graphql } from 'gatsby';

import { ArticleWrapper } from '../../components';

import { transformCaseStudy } from '../../helpers/formatters/formatters';

export default class CaseStudy extends PureComponent {
	constructor(props) {
		super(props);

		this.caseStudy = transformCaseStudy(
			this.props.data.wordsbyCollections
		);
	}

	render() {
		return (
			<main id="main">
				<ArticleWrapper articleContent={this.caseStudy} />
			</main>
		);
	}
}

export const caseStudyQuery = graphql`
	query CaseStudyByID($id: Int!) {
		wordsbyCollections(ID: { eq: $id }) {
			...PostFields
			...HeroComponent

			sections
			locations {
				relationshipByID {
					post_title
				}
			}
			project_types {
				relationshipByID {
					post_title
					pathname
				}
			}
			services {
				relationshipByID {
					post_title
					pathname
				}
			}
			project_features {
				feature
			}
			awards {
				award
			}
			project_quote {
				quote
				attribution_name
				attribution_title
			}
			curated_content {
				relationshipByID {
					...CardComponent
				}
			}
			images {
				imageAttachment {
					...WordsbyAttachment
				}
			}

			...ThumbnailFields

			headline
			location_of_project
			design_architect
			design_solution
			design_impact
			challenge
			featured
		}
	}
`;
